import React, { useState, useEffect, useContext, Fragment } from "react";
import { Row, Col, Avatar, Modal, Upload, Button, Icon } from "antd";
import SectionCard from "./SectionCard";
import { UserContext } from "../../context/UserContext";
import { getEnvironment } from "../../components/orders/helpers";
import moment from "moment";
import DisplayTime from "../../components/common/DisplayTime";
import AppConfig from "../../config/AppConfig";
import { downloadFile } from "../../common/preview";
import I18n from "../../common/I18n";
const Warehouse = (props) => {
  const {
    currentOrder,
    currentOrg,
    isMilitaryTime,
    fromIndividualScreen,
  } = props;
  const [wmsData, setWmsData] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState('');

  const userContext = useContext(UserContext);

  console.log(wmsData,currentOrder, "wmsData");

  const getWmsApiUrlHostName = (key) => {
    switch (key) {
      case "platform":
      case "app1":
      case "legacy":
      case "app":
        return "apigw";

      case "fe-qa":
      case "demo":
        return "api-test";

      default:
        return "api-stage";
    }
  };

  const data = {
    whComments: [
      {
        id: "6710eb3074ad5627426d2ea4",
        createdAt: "2024-10-17T10:49:10.138",
        updatedAt: "2024-10-17T10:47:12.786",
        deletedAt: null,
        referId: "6710e74a8d43e5ccf361eb09",
        organizationId: "6710de78f51ca6601affc7f5",
        comment: "Test",
        refer: I18n.t('general.warehouse'),
        createdBy: "Shipper  Warehouse ",
      },
      {
        id: "6710ef3574ad5627426d2ea9",
        createdAt: "2024-10-17T11:04:55.267",
        updatedAt: "2024-10-17T11:04:21.61",
        deletedAt: null,
        referId: "6710e74a8d43e5ccf361eb09",
        organizationId: "6710de78f51ca6601affc7f5",
        comment: "Received ",
        refer: I18n.t('general.warehouse'),
        createdBy: "Jack Smith",
      },
    ],
    unloadDetails: {
      truckNumber: "T8373",
      doorNumber: "D8383",
    },
    whStatus: "RECEIVED",
    receivedAt: "2024-10-17T11:04:21.97",
    dispatchedAt: null,
    pictures: [
      {
        id: "6710ef3674ad5627426d2eab",
        imageType: "POD",
        ackId: "7f0d2f9d-94fa-4678-a582-9771d61fcef8",
        latitude: 0.0,
        longitude: 0.0,
        signBy: "",
        capturedAt: "2024-10-17T10:48:44.476",
        picture: {
          Url: "https://storage.googleapis.com/kenco/stage/uploads/picture/picture/6710ef3674ad5627426d2eab/20241017110422563.jpg",
        },
        pictureCode: "POD",
        pictureTitle: "POD",
        titleByRelation: "",
        created_at: "2024-10-17T11:04:22.563",
        updated_at: "2024-10-17T11:04:22.563",
        deleted_at: null,
      },
      {
        id: "6710ef3874ad5627426d2eac",
        imageType: "POD",
        ackId: "eaa29236-e377-4925-9dd0-c6829a120c1a",
        latitude: 0.0,
        longitude: 0.0,
        signBy: "",
        capturedAt: "2024-10-17T11:05:39.767",
        picture: {
          Url: "https://storage.googleapis.com/kenco/stage/uploads/picture/picture/6710ef3874ad5627426d2eac/20241017110424174.jpg",
        },
        pictureCode: "POD",
        pictureTitle: "POD",
        titleByRelation: "",
        created_at: "2024-10-17T11:04:24.174",
        updated_at: "2024-10-17T11:04:24.174",
        deleted_at: null,
      },
    ],
    status: "NEW",
  };
  useEffect(() => {
    const fetchWms = async (payload) => {
      const {
        referId = "",
        currentRole = "",
        orgId = "",
        warehouseIds = "",
      } = payload;
      const env = getEnvironment();
      const envUrl = getWmsApiUrlHostName(env);

      const url = `https://${envUrl}.fleetenable.com/api/order/getWhCommentsAndTracks?referId=${referId}&orgId=${orgId}&warehouseIds=${warehouseIds}&currentRole=${currentRole}`;

      try {
        const token_details = JSON.parse(localStorage.getItem("auth") || "{}");
        const token = token_details.access_token;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Accept: "application/json, text/plain, */*",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          return { success: false, errors: ["Failed to fetch WMS data"] };
        }

        const data = await response.json();
        return { success: true, data: data };
      } catch (error) {
        return { success: false, errors: [error] };
      }
    };

    const getWmsDetails = () => {
      const order_id = currentOrder.id;
      const payload = {
        referId: order_id,
        orgId: currentOrg.id,
        warehouseIds: userContext.activeWarehouseid[0],
        currentRole: userContext.currentRole,
      };
      fetchWms({ ...payload }).then((result) => {
        if (result.success) {
          const wmsData = result.data;

          setWmsData({
            unload_details: wmsData.unloadDetails || {},
            wh_comments: wmsData.whComments || [],
            pictures: wmsData.pictures || [],
            pictureTitlePictures: !_.isEmpty(wmsData.pictures)
              ? wmsData.pictures.filter(
                  (e) =>
                    _.get(e, "pictureCode") !== "POD" &&
                    _.get(e, "pictureTitle") !== "POD"
                )
              : [],
            PodPictures: !_.isEmpty(wmsData.pictures)
              ? wmsData.pictures.filter(
                  (e) =>
                    _.get(e, "pictureCode") == "POD" ||
                    _.get(e, "pictureTitle") == "POD"
                )
              : [],
            received_at: wmsData.receivedAt || "",
            wh_status: wmsData.whStatus || "",
            order_status: wmsData.status || "",
            dispatchedAt: wmsData.dispatchedAt || "",
            driverName: wmsData.driverName || "",
            carrier_name: wmsData.carrierName || "",
            shipper_name: wmsData.shipperName || "",
            warehouse_name: wmsData.warehouseName || "",
          });
        } else {
          //const wmsData = data;
          // renderAlertMessage(result.errors)
          setWmsData({
            wmsData: {
              unload_details: {},
              wh_comments: [],
              dispatchedAt: "",
              order_status: '',
              wh_status: "",
              pictureTitlePictures: [],
              PodPictures: [],
              received_at: "",
              dispatchedAt: "",
              driverName: "",
              pictures: [],
              carrier_name: "",
              shipper_name: "",
              warehouse_name: "",
            }
          });
        }
      });

      // wmsPreCall(preCallPayload).then((result) => {
      // if(result.success)
      //   {
      //     fetchWms({...payload , java_token : result.token}).then((result) => {
      //       if (result.success) {
      //         this.setState({
      //           wmsData: {
      //             unload_details: result.unloadDetails,
      //             wh_comments: result.whComments,
      //             pictures: result.pictures,
      //             pictureTitlePictures: !_.isEmpty(result.pictures) ? result.pictures.filter((e) => _.get(e, 'pictureTitle') == 'POD') : [],
      //             PodPictures: !_.isEmpty(result.pictures) ? result.pictures.filter((e) => _.get(e, 'pictureTitle') != 'POD') : [],
      //             received_at: result.receivedAt,
      //             wh_status: result.whStatus,
      //             order_status: result.status,
      //             dispatchedAt: result.dispatchedAt || "",
      //           }
      //         });
      //       } else {
      //         renderAlertMessage(result.errors)
      //         this.setState({
      //           wmsData: {
      //             unload_details: {},
      //             wh_comments: [],
      //             dispatchedAt: "",
      //             order_status: '',
      //             wh_status: "",
      //             pictureTitlePictures: [],
      //             PodPictures: [],
      //             received_at: "",
      //             dispatchedAt: result.dispatchedAt || "",
      //             pictures: []
      //           },
      //           inProgress: false
      //         });
      //       }
      //     });
      //   }
      // })
    };
    getWmsDetails();
  }, [currentOrder?.id]);

  const renderWarehouseDetails = () => {
    const {
      wh_comments,
      unload_details,
      order_status,
      wh_status,
      received_at,
      pictureTitlePictures,
      PodPictures,
      dispatchedAt,
      driverName, 
      pictures,
      carrier_name,
      shipper_name,
      warehouse_name
    } = wmsData;
    const currentOrder = props.currentOrder || {};
    
    return (
      <div className="warehouse-container">
        <Row style={{ marginBottom: "8px" }}>
          <Col className="warehouse-header">
            <span>Unload Details</span>
          </Col>
        </Row>
        <Row style={{ marginBottom: "24px" }}>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor">
              <span className="unload-details-text-left">Door #</span>
            </Col>
            <Col span={12} className="text-borders">
              <span className="unload-details-text-right">
                {unload_details?.doorNumber ? unload_details.doorNumber : "-"}
              </span>
            </Col>
          </Row>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor-child">
              <span className="unload-details-text-left">Truck</span>
            </Col>
            <Col span={12} className="text-borders-child">
              <span className="unload-details-text-right">
                {unload_details?.truckNumber ? unload_details.truckNumber : "-"}
              </span>
            </Col>
          </Row>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor-child">
              <span className="unload-details-text-left">Received At</span>
            </Col>
            <Col span={12} className="text-borders-child">
              <span className="unload-details-text-right">
                {received_at ? (
                  <Fragment>
                    <DisplayTime
                      dateTimeString={received_at} //{"2025-03-19T12:15:27"}
                      timeFormat={AppConfig.dateTimeFormat}
                      displayWithDate={true}
                      timeZoneId={currentOrder.timeZoneId}//{"America/Chicago"}
                      isUTC={true}
                    />
                    {` ${currentOrder.tz_short_name}`}
                  </Fragment>
                ) : (
                  "-"
                )}
              </span>
            </Col>
          </Row>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor-child">
              <span className="unload-details-text-left">{I18n.t("general.warehouse")} Status</span>
            </Col>
            <Col span={12} className="text-borders-child">
              <span className="unload-details-text-right">
                {wh_status ? wh_status : "-"}
              </span>
            </Col>
          </Row>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor-child">
              <span className="unload-details-text-left">Order Status</span>
            </Col>
            <Col span={12} className="text-borders-child">
              <span className="unload-details-text-right">
                {order_status ? order_status : "-"}
              </span>
            </Col>
          </Row>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor-child">
              <span className="unload-details-text-left">Dispatched At</span>
            </Col>
            <Col span={12} className="text-borders-child">
              <span className="unload-details-text-right">
                {!_.isEmpty(dispatchedAt) ? (
                  <Fragment>
                    <DisplayTime
                      dateTimeString={dispatchedAt}
                      timeFormat={AppConfig.dateTimeFormat}
                      displayWithDate={true}
                      timeZoneId={currentOrder.timeZoneId}
                      isUTC={true}
                    />
                    {` ${currentOrder.tz_short_name}`}
                  </Fragment>
                ) : (
                  "-"
                )}
              </span>
            </Col>
          </Row>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor-child">
              <span className="unload-details-text-left">Driver</span>
            </Col>
            <Col span={12} className="text-borders-child">
              <span className="unload-details-text-right">
                {driverName ? driverName : "-"}
              </span>
            </Col>
          </Row>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor-child">
              <span className="unload-details-text-left">Carrier</span>
            </Col>
            <Col span={12} className="text-borders-child">
              <span className="unload-details-text-right">
                {carrier_name ? carrier_name : "-"}
              </span>
            </Col>
          </Row>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor-child">
              <span className="unload-details-text-left">Shipper</span>
            </Col>
            <Col span={12} className="text-borders-child">
              <span className="unload-details-text-right">
                {shipper_name ? shipper_name : "-"}
              </span>
            </Col>
          </Row>
          <Row className="unload-details-item">
            <Col span={12} className="backGroundColor-child">
              <span className="unload-details-text-left">{I18n.t("general.warehouse")}</span>
            </Col>
            <Col span={12} className="text-borders-child">
              <span className="unload-details-text-right">
                {warehouse_name ? warehouse_name : "-"}
              </span>
            </Col>
          </Row>
        </Row>
        <Row style={{ marginBottom: "8px" }}>
          <Col className="warehouse-header">
            <span>Pictures</span>
          </Col>
        </Row>
        {!_.isEmpty(pictureTitlePictures) ? (
          <div className="image-gallery" style={{ marginBottom: "24px" }}>
            <Upload
              listType="picture-card"
              fileList={pictureTitlePictures
                .filter(item => item?.picture?.Url)
                .map((item, index) => ({
                  uid: `-${index}`,
                  name: item.picture.Url.split('/').pop() || `image-${index}`,
                  status: 'done',
                  url: item.picture.Url,
                  thumbUrl: item.picture.Url,
                }))}
              onPreview={(file) => {
                setPreviewFileUrl(file.url || file.thumbUrl);
                setPreviewVisible(true);
              }}
              itemRender={(originNode, file, fileList, actions) => {
                return (
                  <div style={{ position: 'relative' }}>
                    {originNode}
                    <div style={{
                      position: 'absolute',
                      bottom: '4px',
                      right: '4px',
                      display: 'flex',
                      gap: '4px'
                    }}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          downloadFile(file.url, file.name);
                        }}
                        style={{
                          background: 'rgba(0, 0, 0, 0.45)',
                          color: 'white',
                          width: '24px',
                          height: '24px',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                        title="Download"
                      >
                        <Icon type="download" />
                      </a>
                    </div>
                  </div>
                );
              }}
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: true
              }}
            />
            <Modal
              visible={previewVisible}
              footer={null}
              onCancel={() => setPreviewVisible(false)}
              width="auto"
              style={{ top: 20 }}
            >
              <div style={{ display: 'flex', flexDirection:"column", alignItems: 'center', gap: '16px' }}>
                <img
                  alt="Preview"
                  src={previewFileUrl}
                  style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                />
                <Button
                  type="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    const fileName = previewFileUrl.split('/').pop() || 'image';
                    downloadFile(previewFileUrl, fileName);
                  }}
                  >
                  Download
                </Button>
                  </div>
            </Modal>
          </div>
        ) : (
          <SectionCard>
            <h2>No pictures found</h2>
          </SectionCard>
        )}

        <Row style={{ marginBottom: "8px" }}>
          <Col className="warehouse-header">
            <span>OS & D Pictures</span>
          </Col>
        </Row>
        {!_.isEmpty(PodPictures) ? (
          <div className="image-gallery" style={{ marginBottom: "24px" }}>
            <Upload
              listType="picture-card"
              fileList={PodPictures
                .filter(item => item?.picture?.Url)
                .map((item, index) => ({
                  uid: `-${index}`,
                  name: item.picture.Url.split('/').pop() || `image-${index}`,
                  status: 'done',
                  url: item.picture.Url,
                  thumbUrl: item.picture.Url,
                }))}
              onPreview={(file) => {
                setPreviewFileUrl(file.url || file.thumbUrl);
                setPreviewVisible(true);
              }}
              itemRender={(originNode, file) => {
                return (
                  <div style={{ position: 'relative' }}>
                    {originNode}
                    <div
                      style={{
                        position: 'absolute',
                        bottom: '4px',
                        right: '4px',
                        display: 'flex',
                        gap: '4px',
                      }}
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          downloadFile(file.url, file.name);
                        }}
                        style={{
                          background: 'rgba(0, 0, 0, 0.45)',
                          color: 'white',
                          width: '24px',
                          height: '24px',
                          borderRadius: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '12px',
                          cursor: 'pointer',
                        }}
                        title="Download"
                      >
                        <Icon type="download" />
                      </a>
                    </div>
                  </div>
                );
              }}
              showUploadList={{
                showRemoveIcon: false,
                showPreviewIcon: true,
              }}
            />

            <Modal
              visible={previewVisible}
              footer={null}
              onCancel={() => setPreviewVisible(false)}
              width="auto"
              style={{ top: 20 }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: "column",
                  alignItems: 'center',
                  gap: '16px',
                }}
              >
                <img
                  alt="Preview"
                  src={previewFileUrl}
                  style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                />
                <Button
                  type="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    const fileName = previewFileUrl.split('/').pop() || 'image';
                    downloadFile(previewFileUrl, fileName);
                  }}
                >
                  Download
                </Button>
              </div>
            </Modal>
          </div>
        ) : (
          <SectionCard>
            <h2>No pictures found</h2>
          </SectionCard>
        )}
        <Row style={{ marginBottom: "8px" }}>
          <Col className="warehouse-header">
            <span>{I18n.t('general.warehouse')} Comments</span>
          </Col>
        </Row>
        <div className="comments-list">
          {wh_comments ? (
            wh_comments.map((comment) => (
              <SectionCard
                key={comment.id}
                className="warehouse-comment-card"
                style={{ marginBottom: "16px" }}
              >
                <div className="comment-header">
                  <div className="comment-text">
                    {/* <img
                      className="comment-profile"
                      src={comment.userImage ? comment.userImage : " "}
                      alt={`${comment.userName}'s profile`}
                    /> */}
                    <Avatar size="small" icon="user" />

                    <span className="user-name">
                      {comment.createdBy ? comment.createdBy : "Not Available"}
                    </span>
                  </div>
                  <div className="comment-time">
                    {comment.createdAt
                      ? moment(comment.createdAt).fromNow()
                      : "Not Available"}
                  </div>
                </div>
                <div className="comment-body">
                  <span>
                    {comment.comment ? comment.comment : "Not Available"}
                  </span>
                </div>
                <div className="comment-category">{comment.category}</div>
              </SectionCard>
            ))
          ) : (
            <SectionCard>
              <h2>No comments found</h2>
            </SectionCard>
          )}
          {/* </div> */}
        </div>
      </div>
    );
  };

  return <div>{renderWarehouseDetails()}</div>;
};

export default Warehouse;
